import { render, staticRenderFns } from "./ops_board.vue?vue&type=template&id=2123d549&scoped=true&"
import script from "./ops_board.vue?vue&type=script&lang=js&"
export * from "./ops_board.vue?vue&type=script&lang=js&"
import style0 from "./ops_board.vue?vue&type=style&index=0&id=2123d549&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2123d549",
  null
  
)

export default component.exports